import styled from 'styled-components';

export const Title = styled.p`
  font-weight: bold;
`;
